export default "__VITE_ASSET__Cjk33cMr__"